import router from "@/router/index.js";
import axios from "axios";
import firebase from "@/Firebase.js";
import CookieManager from "@/utils/cookieManager.js";
import AuthService from "@/services/AuthService";
import Store from "@/store";

async function setJwtCookie() {
  await firebase
    .auth()
    .currentUser?.getIdToken(false)
    .then((idToken) => {
      if (process.env.NODE_ENV === "production") {
        CookieManager.createCookie(
          "_jwt",
          idToken,
          60,
          "Strict",
          true,
          ".gestaohexa.com.br"
        );
      } else {
        CookieManager.createCookie("_jwt", idToken, 60, "Strict", true);
      }
    })
    .catch((error) => {
      console.log("Erro ao recuperar Id Token do Usuário: ", error);
    });
}

export default {
  apiCall() {
    axios.defaults.withCredentials = true;

    let CustomHeader = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };

    let baseURL = process.env.VUE_APP_API_BASE_URL;

    let call = axios.create({
      baseURL: baseURL,
      headers: CustomHeader,
      withCredentials: true,
      timeout: 60 * 4 * 1000,
    });

    call.interceptors.request.use(
      async (config) => {
        await setJwtCookie();
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    call.interceptors.response.use(
      (response) => {
        if (response.status === 200 || response.status === 201) {
          return Promise.resolve(response);
        } else {
          return Promise.reject(response);
        }
      },
      (error) => {
        if (error.response && error.response.status) {
          switch (error.response.status) {
            case 401:
            case 403:
              AuthService.logout();
              break;
          }

          /* Formata Message Response de BLOB para JSON */
          if (
            error.request.responseType === "blob" &&
            error.response.data instanceof Blob &&
            error.response.data.type &&
            error.response.data.type.toLowerCase().indexOf("json") != -1
          ) {
            return new Promise((resolve, reject) => {
              let reader = new FileReader();
              reader.onload = (result) => {
                error.response.data = JSON.parse(result.target.result);
                resolve(Promise.reject(error));
              };

              reader.onerror = () => {
                reject(error);
              };

              reader.readAsText(error.response.data);
            });
          }

          return Promise.reject(error.response);
        } else {
          return Promise.reject(error);
        }
      }
    );
    return call;
  },
};
